import { render } from "./offLineTicket.vue?vue&type=template&id=32fa6c59&scoped=true"
import script from "./offLineTicket.vue?vue&type=script&lang=js"
export * from "./offLineTicket.vue?vue&type=script&lang=js"

import "./offLineTicket.vue?vue&type=style&index=0&id=32fa6c59&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fa6c59"]])

export default __exports__